module.exports = __webpack_public_path__ + "media/images/flags/en-5d8ca684eb61ba09a56f68280e4b0a50.png";